module.exports = __webpack_public_path__ + "static/media/battery@3x.634fe330.png";